import Vue from 'vue';
import zhInput from './input/index.js'
import zhLoading from './zhloading/index.js'
import zhDialog from './zhdialog/index.js'
import topBar from './topBar/index.js'
const components = [
  zhInput,
  zhLoading,
  zhDialog,
  topBar
]
const install = function(Vue) {
  console.log(install.installed,'installed')
  if (install.installed){
    return ;
  }
  components.map(component => Vue.component(component.name, component));
};
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  zhInput,
  zhLoading,
  zhDialog,
  topBar
}




// WEBPACK FOOTER //
// ./ui/main.js